export const defaultDate = function() {
  // 获取天 年月日
  const endYear = new Date().getFullYear();
  const endMonth = new Date().getMonth() + 1;
  const endDate = new Date().getDate();
  // 获取14天前的时间戳
  const startTimestamp =
    new Date(endYear + '-' + endMonth + '-' + endDate).getTime() - 86400000 * 14;
  // 获取14天前 年月日
  const startYear = new Date(startTimestamp).getFullYear();
  const startMonth = new Date(startTimestamp).getMonth() + 1;
  const startDate = new Date(startTimestamp).getDate();
  // 拼接数据
  const startTime = startYear + '-' + startMonth + '-' + startDate + ' 00:00:00';
  const endTime = endYear + '-' + endMonth + '-' + endDate + ' 23:59:59';
  return [startTime, endTime];
};
export const disabledDate = time => {
  // 限制时间选择一年内
  const nowDate = new Date().toString(); // 获取时间转字符串
  const nowDateYear = new Date().getFullYear(); // 当前时间的年份
  // 字符串年份替换为一年前
  const oneYearAgoDate = nowDate.replace(nowDateYear, nowDateYear - 1);
  // 一年前字符串转为时间戳
  const oneYear = new Date(oneYearAgoDate).getTime();
  return time.getTime() > Date.now() || time.getTime() < oneYear;
};
